<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button, Form, FormItem, Input, InputNumber, Modal } from "view-design";
import Deal from "./deal.vue";
import Mod from "./modal.vue";
export default {
  extends: baseList,
  components: {
    deal: Deal,
    mod: Mod,
  },
  data() {
    return {
      table: {
        mname: "user",
        key: "uid",
        url: { field: "/admin/api/user/edit" },
        output: false,
      },
      form: {},
      menus: [
        {
          label: "用户列表",
          name: "user_list",
          auth: "/admin/user/lists",
        },
        // {
        //   label: "浏览记录",
        //   name: "record_list",
        //   auth: "/admin/record/lists",
        // },
        {
          label: "团队列表",
          name: "squad_list",
          auth: "/admin/squad/lists",
        },
      ],
      actions: [
        // {label: '新增', icon: 'md-add', onClick: this.toAdd, auth1: '/admin/user/add'},
        // {
        //   label: "测试不同月份水票，请勿自行操作",
        //   // icon: "md-add",
        //   onClick: this.test,
        //   auth: "/admin/user/add",
        // },
      ],
      tactions: [
        //   { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '用户数据', 0), auth: '/admin/user/lists' },
        //   { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '用户数据', 1), auth: '/admin/user/lists' },
      ],
      query: {},
      filters: [
        { label: "昵称", name: "user_nick", value: "", type: "input" },
        { label: "手机号", name: "user_mobile", value: "", type: "input" },
        // {
        //   label: "团队",
        //   name: "squad_id",
        //   value: 1,
        //   type: "select",
        //   dropList: [],
        // },
        {
          label: '团队',
          name: 'squad_id',
          value: 1,
          type: 'select_group',
          dropList: [],
        },
        {
          label: "身份",
          name: "user_type",
          value: 1,
          type: "select",
          dropList: [
            { value: 1, name: "游客" },
            { value: 2, name: "普通用户" },
            { value: 3, name: "讲师" },
          ],
        },
      ],
      tableCols: [
        // {
        //   type: 'selection',
        //   width: 60,
        // },
        {
          title: "UID",
          key: "uid",
          width: 80,
          align: "center",
        },
        {
          title: "头像",
          key: "user_head",
          width: 80,
          align: "center",
          isAvatar: true,
          viewimage: true,
        },
        {
          title: "昵称",
          key: "user_nick",
          minWidth: 120,
        },
        {
          title: "手机号",
          key: "user_mobile",
          width: 130,
        },
        {
          title: "身份",
          width: 100,
          key: "user_type",
          // align: "center",
          render: (h, { row }) => {
            if (row.user_type == 1) {
              return <span>游客</span>;
            } else if (row.user_type == 2) {
              return <span>普通用户</span>;
            } else if (row.user_type == 3) {
              return <span>讲师</span>;
            }
          },
        },
        {
          title: "团队",
          minWidth: 200,
          key: "squad_name",
          // align: "center",
        },
        {
          title: "水票",
          key: "point",
          width: 100,
        },
        {
          title: "权量",
          key: "water_rule_num",
          width: 100,
          editable: true,
          ady: true,
        },
        // {
        //   title: "是否实名",
        //   align: "center",
        //   key: "is_real",
        //   minWidth: 100,
        //   switch: true,
        //   disabled: false,
        // },
        // {
        //   title: "是否实名",
        //   key: "is_real",
        //   minWidth: 120,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const color =
        //       row.is_real == 1 ? "blue" : row.is_real == 0 ? "red" : "";
        //     const text =
        //       row.is_real == 1 ? "是" : row.is_real == 0 ? "否" : "";
        //     return (
        //       <span style={{ color: color, "font-size": "14px" }}>{text}</span>
        //     );
        //   },
        // },
        // {
        //   title: "性别",
        //   key: "user_gender",
        //   minWidth: 70,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const color =
        //       row.user_gender == 1 ? "blue" : row.user_gender == 2 ? "red" : "";
        //     const text =
        //       row.user_gender == 1 ? "男" : row.user_gender == 2 ? "女" : "";
        //     return (
        //       <span style={{ color: color, "font-size": "14px" }}>{text}</span>
        //     );
        //   },
        // },
        {
          title: "账号状态",
          align: "center",
          key: "status",
          width: 100,
          switch: true,
          disabled: false,
        },
        {
          title: "备注",
          align: "center",
          key: "remark",
          minWidth: 120,
        },
        {
          title: "最次一次登录时间",
          key: "last_login_time",
          width: 170,
          align: "center",
        },
        {
          title: "创建时间",
          key: "create_time",
          width: 170,
          align: "center",
        },
        {
          title: "小程序Openid",
          align: "center",
          key: "mini_openid",
          minWidth: 150,
          copy: true
        },
        {
          title: "操作",
          align: "center",
          width: 230,
          key: "handle",
          fixed: "right",
          handle: [
            "edit",
            "delete",
            // (vm, h, currentRow, param) => {
            //   const row = param.row;
            //   let directives = [{ name: "auth", value: "/admin/user/edit" }];
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.Detail(currentRow)}
            //       type="warning"
            //       style={{ margin: "4px 5px" }}
            //     >
            //       调整水票
            //     </Button>
            //   );
            // },
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [{ name: "auth1", value: "/admin/user/get" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toAccount(currentRow)}
                  type="success"
                  style={{ margin: "4px 5px" }}
                >
                  水票记录
                </Button>
              );
            },
          ],
          auth: {
            edit: "/admin/user/edit",
            del: "/admin/user/del",
          },
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    toEdit(row) {
      let uid = row.uid;
      $utils.url.push({
        name: "user_edit",
        query: { action: "edit", kv: uid },
      });
    },
    toComment(row) {
      let uid = row.uid;
      $utils.url.push({
        name: "record_list",
        query: { kv: uid },
      });
    },
    Detail(row) {
      Modal.confirm({
        render: () => <Mod obj={row} that={this} ref={"aaa"}></Mod>,
        ok: this.ok,
      });
    },
    ok() {
      return this.$refs.aaa.handleSubmit();
    },
    async init() {
      let q = {}
      let res = await $utils.api.load('admin/api/squad/dropTree', q)
      if (res && res.data) {
        let ll = res.data
        let dropList = []
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index]
          let xx = {}
          xx.value = element.id
          xx.name = element.name
          xx.disabled = true
          xx.children = element.children || []
          dropList.push(xx)
        }
        for (let index = 0; index < this.filters.length; index++) {
          const element = this.filters[index]
          if (element && element.name == 'squad_id') {
            this.filters[index]['dropList'] = dropList
          }
        }
        console.log('dropList squad_id', dropList)
      }
    },
    // init() {
    //   let dropList = [];
    //   $utils.api.load("admin/api/squad/lists", {}).then((res) => {
    //     // if (res.code == 1) {
    //     // console.log(this.items, res.data.list, 222222222);
    //     for (let index = 0; index < res.data.list.length; index++) {
    //       const element = res.data.list[index];
    //       dropList.push({
    //         name: element.name,
    //         value: element.id,
    //       });
    //     }
    //     for (let index = 0; index < this.filters.length; index++) {
    //       let elment = this.filters[index];
    //       if (elment && elment.name == "squad_id") {
    //         elment.dropList = dropList;
    //       }
    //     }
    //     // }
    //   });
    // },
    toAccount(row) {
      let uid = row.uid;
      $utils.url.push({
        name: "account_list",
        query: { kv: uid },
      });
    },
    test() {
      $utils.api.load("syncwatertest", {}).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
